export default "__VITE_ASSET__CSps073i__"